import { render, staticRenderFns } from "./SecondaryProductRecommendation.vue?vue&type=template&id=66d802c5&scoped=true&"
import script from "./SecondaryProductRecommendation.vue?vue&type=script&lang=js&"
export * from "./SecondaryProductRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryProductRecommendation.vue?vue&type=style&index=0&id=66d802c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d802c5",
  null
  
)

export default component.exports